const TONES = {
  white: "tone-white bg-white text-brown",
  blush: "tone-blush bg-blush/40 text-brown",
  plum: "tone-plum grain bg-plum text-white",
  night: "tone-night grain bg-[#0B0A0A] text-white",
  aubergine: "tone-aubergine grain bg-[#141011] text-white",
  slate: "tone-slate grain bg-[#1A1213] text-white",
  ceremony: "tone-ceremony grain bg-[#7A0F1A] text-white",
};

export const Section = ({ id, tone = "plum", className = "", children, testid }) => (
  <section id={id} data-testid={testid || (id ? `section-${id}` : undefined)} className={`relative ${TONES[tone]} ${className}`}>
    <div className="mx-auto w-full max-w-[1320px] px-6 md:px-12">{children}</div>
  </section>
);

const COLOR = { aubergine: "#141011", slate: "#1A1213", ceremony: "#7A0F1A", blush: "var(--color-blush-soft)", white: "var(--color-white)", plum: "var(--color-plum)", night: "var(--color-night)" };

export const Bridge = ({ from = "night", to = "white", className = "" }) => (
  <div aria-hidden="true" className={`bridge h-32 md:h-52 ${className}`} style={{ "--from": COLOR[from], "--to": COLOR[to] }} data-testid={`bridge-${from}-${to}`} />
);

export const Photo = ({ src, alt, frame = "rect", className = "", imgClass = "", style, children }) => (
  <div className={`relative overflow-hidden rounded-[5px] bg-night ${className}`} style={style}>
    <img src={src} alt={alt} loading="lazy" className={`photo-treat h-full w-full object-cover ${imgClass}`} />
    <div className="photo-duo absolute inset-0" aria-hidden="true" />
    <div className="photo-spot absolute inset-0" aria-hidden="true" />
    <div className="photo-vignette absolute inset-0" aria-hidden="true" />
    {children}
  </div>
);

export const BottleSilhouette = ({ className = "" }) => (
  <svg viewBox="0 0 100 160" className={className} fill="none" aria-hidden="true">
    <path d="M42 8h16v14H42zM36 22h28l6 18v102a8 8 0 0 1-8 8H38a8 8 0 0 1-8-8V40z" stroke="currentColor" strokeWidth="0.7" />
    <path d="M36 70h28" stroke="currentColor" strokeWidth="0.5" />
  </svg>
);
